<div class="policy">
  <div class="faq-sub-question-title">Policy questions</div>
  <section [multiple]="false">
    <div class="padding-vertical pv16 faq-border-bottom">
      <a class="faq-link-item" (click)="closeNonActiveCollapse('one')" mdbRipple [class.active]="accordianWithMDB.one">
        <div class="faq-item">
          <div class="faq-item-title">Where are my insurance cards?</div>
          <div class="faq-arrow-block">       
            <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.one" alt="simple down arrow" />
            <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.one" alt="simple up arrow" />
          </div>
        </div>
      </a>
      <div class="padding-left pl16" #one [class.fake-accourdian]="!accordianWithMDB.one">
        <div class="faq-answ-block">
          In Massachusetts, insurance ID cards are not required.
        </div>
      </div>
    </div>

    <div class="padding-vertical pv16 faq-border-bottom">
      <a class="faq-link-item" (click)="closeNonActiveCollapse('two')" mdbRipple [class.active]="accordianWithMDB.two">
        <div class="faq-item">
          <div class="faq-item-title">What info is on my personal auto coverage selection page(s)?</div>
          <div class="faq-arrow-block">            
            <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.two" alt="simple down arrow" />
            <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.two" alt="simple up arrow" />
          </div>
          </div>
      </a>
      <div class="padding-left pl16" #two  [class.fake-accourdian]="!accordianWithMDB.two">
        <div class="faq-answ-block">
          You can review your listed vehicles, coverages, drivers, and discounts on your coverage selections page.
        </div>
      </div>
    </div>

    <div class="padding-vertical pv16 faq-border-bottom">
      <a class="faq-link-item" (click)=" closeNonActiveCollapse('three')" mdbRipple [class.active]="accordianWithMDB.three">
        <div class="faq-item">
          <div class="faq-item-title">What is the policy renewal process?</div>
          <div class="faq-arrow-block">          
            <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.three" alt="simple down arrow" />
            <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.three" alt="simple up arrow" />
          </div>
        </div>
      </a>
      <div class="padding-left pl16" #three [class.fake-accourdian]="!accordianWithMDB.three">
        <div class="faq-answ-block">
          <div>With automatic renewal, you won't be left with a lapse in insurance due to your policy expiring unknowingly. All that is required is payment on your renewal bill, and you are all set! Below are the steps in the process, along with considerations you may want to discuss with your agent.</div><br> 
          <div>Review policy</div>
          <div>30 days prior to your renewal date, your Mapfre renewal package will be available, and 20 days prior to your renewal date, your renewal bill will be sent. Your policy will be mailed to you or delivered electronically if you are enrolled in paperless. Please review it to confirm all details are correct and update anything as needed.</div><br>
          <div>Why did my rate change?</div>
          <div>When you get your renewal offer, you may notice that your rate has changed. This can happen for a number of reasons, such as life events, driving experience, and/or accidents.</div><br>
          <div>Policy questions or updates?</div>
          <div>Renewal is a good time to review your coverages and ensure you are fully protected.</div><br>
          <div><a routerLink="/contact" class="font-weight-normal red-text underlineBQ">Contact your agent</a> if you have questions or changes to your policy, including if you have moved.</div>
          </div>
      </div>
    </div>

    <div class="padding-vertical pv16 faq-border-bottom">
      <a class="faq-link-item" (click)=" closeNonActiveCollapse('four')" mdbRipple [class.active]="accordianWithMDB.four">
        <div class="faq-item">
          <div class="faq-item-title">How do I update my annual mileage?</div>
          <div class="faq-arrow-block">          
            <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.four" alt="simple down arrow" />
            <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.four" alt="simple up arrow" />
          </div>
        </div>
      </a>
      <div class="padding-left pl16"  #four [class.fake-accourdian]="!accordianWithMDB.four">
        <div class="faq-answ-block">
          After your policy's effective date, you can enter an odometer reading on the Policies page in the Overview tab. Once submitted, it will be processed, and your policy will be updated accordingly.
          </div>
      </div>
    </div>

    <div class="padding-vertical pv16 faq-border-bottom">
      <a class="faq-link-item" (click)=" closeNonActiveCollapse('five')" mdbRipple [class.active]="accordianWithMDB.five">
        <div class="faq-item">
          <div class="faq-item-title">Why purchase renter’s Insurance?</div>
          <div class="faq-arrow-block">          
            <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.five" alt="simple down arrow" />
            <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.five" alt="simple up arrow" />
          </div>
        </div>
      </a>
      <div class="padding-left pl16" #five [class.fake-accourdian]="!accordianWithMDB.five">
        <div class="faq-answ-block">
          <div>Renters insurance is a policy that protects your personal property and personal liability against losses such as fire, theft, smoke, vandalism, and injury to others.</div><br>
          <div>
           While some renters may not see a need for renters insurance because they don't own the home, it is important to remember the things inside the home, such as clothes, furniture, sports equipment, antiques, electronics, artwork, and more. Renter's insurance coverage is available to protect these types of items.
          </div><br>
          <div>
            Renter's insurance also covers you legally if a guest gets hurt or damages your property while visiting your home.
          </div>
          </div>
      </div>
    </div>

    <div class="padding-vertical pv16 faq-border-bottom">
      <a class="faq-link-item" (click)=" closeNonActiveCollapse('six')" mdbRipple [class.active]="accordianWithMDB.six">
        <div class="faq-item">
          <div class="faq-item-title">Do I really need condo insurance?</div>
          <div class="faq-arrow-block">          
            <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.six" alt="simple down arrow" />
            <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.six" alt="simple up arrow" />
          </div>
        </div>
      </a>
      <div class="padding-left pl16" #six [class.fake-accourdian]="!accordianWithMDB.six">
        <div class="faq-answ-block">
          <div>If you are a condo owner, you are likely part of a condo association that carries condo insurance for the buildings. However, it's best to also have a condo insurance policy that covers your personal belongings and personal liability. Inside your condo are cherished items, including furniture, clothing, and household goods, which can be protected in the event of fire, lightning, vandalism, theft, and other perils with the personal property protection of your condominium insurance policy.</div><br>
          <div>
            If you have friends or relatives staying in your condo, personal liability protection will cover your legal responsibility for any accidents involving people or property caused by you, a family member, or your pets.
          </div>
        </div>
      </div>
    </div>

    <div class="padding-vertical pv16 faq-border-bottom">
      <a class="faq-link-item" (click)=" closeNonActiveCollapse('seven')" mdbRipple [class.active]="accordianWithMDB.seven">
        <div class="faq-item">
          <div class="faq-item-title">What additional property coverage is available?</div>
          <div class="faq-arrow-block">          
            <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.seven" alt="simple down arrow" />
            <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.seven" alt="simple up arrow" />
          </div>
        </div>
      </a>
      <div class="padding-left pl16" #seven [class.fake-accourdian]="!accordianWithMDB.seven">
        <div class="faq-answ-block">
          <div>To extend your policy’s basic protection and to cover a wider range of circumstances, additional endorsements may be purchased to cover:</div><br>
          <ul class="mb-0 faq-ul">
            <li>Water and sewer backup coverage.</li>
            <li>Replacement cost coverage for your home’s contents.</li>
            <li>Credit card, forgery, and counterfeit money protection.</li>
            <li>Increased limits for personal liability and medical payment.</li>
            <li>Personal injury liability protection.</li>
            <li>Increased limits on certain personal property such as jewelry, silverware, and furs.</li>
            <li>Special personal property coverage for most perils affecting your home’s contents.</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="padding-vertical pv16 faq-border-bottom">
      <a class="faq-link-item" (click)=" closeNonActiveCollapse('eight')" mdbRipple [class.active]="accordianWithMDB.eight">
        <div class="faq-item">
          <div class="faq-item-title">How do I cancel my policy?</div>
          <div class="faq-arrow-block">          
            <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.eight" alt="simple down arrow" />
            <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.eight" alt="simple up arrow" />
          </div>
        </div>
      </a>
      <div class="padding-left pl16 faq-question " #eight [class.fake-accourdian]="!accordianWithMDB.eight">
        <div class="faq-answ-block sendus-msg-link-sec">
          If you want to cancel your policy, please <app-billing-question [buttonText]="'send us a message'" class="no-margin"></app-billing-question> or <a routerLink="/contact" class="font-weight-normal red-text underlineBQ">contact your agent</a> to help you with this process. 
          </div>
      </div>
    </div>
  </section>

  <div class="row margin-top mt24 text-center">
    <div class="col">

      <a routerLink="/faq" class="faq-back"><img src="assets/img/images/faq-icon-strong-arrow-left.svg" class="align-middle pr-1"><p class="faq-back-btn">{{ 'BACK' | translate }}</p></a>
    </div>
  </div>
</div>
